// extracted by mini-css-extract-plugin
module.exports = {"root":"playlists_root__2Yrvd","content":"playlists_content__4kMpV","leftSide":"playlists_leftSide__d21TH","rightSide":"playlists_rightSide__2YngO"};